export const imgSrc = 'https://image.tmdb.org/t/p/w500/';
export const primaryBackgroundColor = '#1F1F1F';
